import axios from "axios";

export const submitCampaignForm = async (payload: {}) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/company/campaign/create`,

      payload,
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (response.data.statusCode === "OK") {
      return true;
      // localStorage.setItem("companyName", response.data.data.companyName);
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during campaign form submit:", error);
    return false;
  } finally {
  }
};

export const getCampaignDetails = async (campaignId: string) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/admin/campaign/${campaignId}/active`
    );
    if (response.data.statusCode === "OK") {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during company name change:", error);
    return false;
  } finally {
  }
};
